import request from './common/request'

import { MERCHANT_EVALUATION_EXPORT_ENTRY_PDF_TASKS_URI } from './urls'

/**
 * 分页查询导出任务（商户维度，跨评审项目）
 * @param {Object} params page, pageSize, evalProjectId?, competitionId?, status?, beginTime?, endTime?
 */
async function listTasks (params) {
  return request({
    url: MERCHANT_EVALUATION_EXPORT_ENTRY_PDF_TASKS_URI,
    method: 'GET',
    params
  })
}

export default {
  listTasks
}



// WEBPACK FOOTER //
// ./src/api/merchant-evaluation-export-entry-pdf.js